import { render, staticRenderFns } from "./XyOis.vue?vue&type=template&id=dbde21f8"
import script from "./XyOis.vue?vue&type=script&lang=js"
export * from "./XyOis.vue?vue&type=script&lang=js"
import style0 from "./XyOis.vue?vue&type=style&index=0&id=dbde21f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports